module.exports = __webpack_public_path__ + "img/goerli.094d3b83.svg";